import {
  showErrorMessage,
  showSuccessMessage,
} from '../../../components/ToastComponent/store/toastMiddleware';
import { type AppDispatch } from '../../../redux/store';
import { createInterestScheme, getInterestScheme, getBankInterestScheme, createBank, getBank, getBranch, createBankInterestScheme, updateBankInterestScheme, createBankAccount, getBankAccountNamesWithStats, updateBankAccountLimits, createAgent, getAgents, getAgentsByBranch, updateAgent, deleteAgent, type BankAccountLimitsPayload } from './interestSchemeMiddleware';
import { type AgentListResponse, type BankAccount, type BankInterestScheme, type LoanOption } from './interestSchemeTypes';

export const createInterestSchemeAction = async (
  dispatch: AppDispatch,
  payload: LoanOption
) => {
  const data = {
    ...payload,
  };
  const res = await dispatch(createInterestScheme(data));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Interest scheme created successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error creating interest scheme'));
    return false;
  }
};

export const createBankInterestSchemeAction = async (
  dispatch: AppDispatch,
  payload: BankInterestScheme
) => {
  const data = {
    ...payload,
  };
  const res = await dispatch(createBankInterestScheme(data));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Bank Interest scheme created successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error creating bank interest scheme'));
    return false;
  }
};

export const updateBankInterestSchemeAction = async (
  dispatch: AppDispatch,
  payload: {
    id: string,
    minGoldRate?: number,
    isActive?: boolean,
    documentChargeType?: string,
    documentCharge?: number,
    appraisalChargeType?: string,
    appraisalCharge?: number
  }
) => {
  const data = {
    ...payload,
  };
  const res = await dispatch(updateBankInterestScheme(data));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Bank Interest scheme updated successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error updating bank interest scheme'));
    return false;
  }
};

export const createBankAccountAction = async (
  dispatch: AppDispatch,
  payload: BankAccount
) => {
  const data = {
    ...payload,
  };
  const res = await dispatch(createBankAccount(data));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Bank account created successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error creating bank account'));
    return false;
  }
};

export const createBankAction = async (
  dispatch: AppDispatch,
  payload: {name: string}
) => {
  const data = {
    ...payload,
  };
  const res = await dispatch(createBank(data));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Bank created successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error creating bank'));
    return false;
  }
};

export const getInterestSchemeAction = async (
  dispatch: AppDispatch,
  payload: { branch?: string }
) => {
  const res = await dispatch(getInterestScheme(payload));
  console.log(res);
};

export const getBankInterestSchemeAction = async (
  dispatch: AppDispatch,
  payload: {branch: string}
) => {
  const res = await dispatch(getBankInterestScheme(payload));
  return res.payload;
};

export const getBankNameAction = async (
  dispatch: AppDispatch,
  payload: { branch?: string }
) => {
  const res = await dispatch(getBank(payload));
  console.log(res);
};

export const getBranchAction = async (
  dispatch: AppDispatch,
  payload: any
) => {
  const res = await dispatch(getBranch(payload));
  console.log(res);
};

export const getBankAccountNamesWithStatsAction = async (
  dispatch: AppDispatch,
  payload: { branch: string }
) => {
  const res = await dispatch(getBankAccountNamesWithStats(payload));
  if (res.meta.requestStatus === 'fulfilled') {
    return res.payload;
  } else {
    dispatch(showErrorMessage('Error fetching bank account stats'));
    return null;
  }
};

export const updateBankAccountLimitsAction = async (
  dispatch: AppDispatch,
  payload: BankAccountLimitsPayload
) => {
  const res = await dispatch(updateBankAccountLimits(payload));
  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Limits updated successfully'));
    return true;
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error updating limits'));
    return false;
  }
};

export const createAgentAction = async (
  dispatch: AppDispatch,
  payload: { branch: string; agentCode: string; agentName: string }
) => {
  const res = await dispatch(createAgent(payload));
  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Agent created successfully'));
    return true;
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error creating agent'));
    return false;
  }
};

export const getAgentsAction = async (
  dispatch: AppDispatch,
  payload: { branch?: string; search?: string; page?: number; limit?: number }
): Promise<AgentListResponse | null> => {
  const res = await dispatch(getAgents(payload));
  if (res.meta.requestStatus === 'fulfilled') {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return res.payload;
  }
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error fetching agents'));
  return null;
};

export const getAgentsByBranchAction = async (
  dispatch: AppDispatch,
  payload: { branch: string }
) => {
  const res = await dispatch(getAgentsByBranch(payload));
  if (res.meta.requestStatus === 'fulfilled') {
    return res.payload;
  }
  return [];
};

export const updateAgentAction = async (
  dispatch: AppDispatch,
  payload: { id: string; agentCode?: string; agentName?: string; branch?: string }
) => {
  const res = await dispatch(updateAgent(payload));
  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Agent updated successfully'));
    return true;
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error updating agent'));
    return false;
  }
};

export const deleteAgentAction = async (
  dispatch: AppDispatch,
  id: string
) => {
  const res = await dispatch(deleteAgent(id));
  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Agent deleted successfully'));
    return true;
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error deleting agent'));
    return false;
  }
};